<template>
    <!-- 头部导航栏 -->
    <div class="top-nav">
        <div class="nav-container">
            <!-- Logo部分 -->
            <div class="logo-section">
                <div class="logo" v-if="LogoStatus === 1 && logoURL">
                    <img :src=logoURL alt="ceeac">
                </div>
                <!-- <div class="logo-text">
                    <span class="org-name">中国电机工程学会</span>
                </div> -->
            </div>
            
            <!-- PC端导航菜单 -->
            <div class="nav-menu desktop-menu">
                <!-- 登录/注册之前的普通菜单项 -->
                <div 
                    class="nav-item" 
                    :class="{ 'active': currentActiveId === item.id }"
                    v-for="item in beforeRegisterItems" 
                    :key="item.id"
                    @click="handleMenuClick(item)"
                >
                    {{item.nameCn}}
                </div>
                <!-- 登录/注册按钮 -->
                <div class="register-btn" v-if="registerItem" @click="handleMenuClick(registerItem)">
                    {{registerItem.nameCn}}
                </div>
                <!-- 退费申请按钮 -->
                <div class="refund-btn" v-if="refundItem" @click="handleMenuClick(refundItem)">
                    {{refundItem.nameCn}}
                </div>
                <!-- 年会报名按钮 -->
                <div class="register-btn" v-if="annualItem" @click="handleMenuClick(annualItem)">
                    {{annualItem.nameCn}}
                </div>
            </div>

            <!-- 年会报名按钮 - 移动端顶部显示 -->
            <div class="register-btn mobile-only" v-if="annualItem" @click="handleMenuClick(annualItem)">
                {{annualItem.nameCn}}
            </div>
            
            <!-- 移动端汉堡菜单按钮 -->
            <div class="mobile-menu-btn" @click="toggleMobileMenu">
                <div class="hamburger" :class="{ 'active': showMobileMenu }">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
        
        <!-- 移动端菜单面板 -->
        <div class="mobile-menu-panel" :class="{ 'show': showMobileMenu }">
            <div class="mobile-menu-content">
                <!-- 登录/注册之前的普通菜单项 -->
                <div 
                    class="mobile-nav-item" 
                    :class="{ 'active': currentActiveId === item.id }"
                    v-for="item in beforeRegisterItems" 
                    :key="item.id"
                    @click="handleMobileMenuClick(item)"
                >
                    {{item.nameCn}}
                </div>
                <!-- 登录/注册按钮 -->
                <div class="mobile-register-btn" v-if="registerItem" @click="handleMobileMenuClick(registerItem)">
                    {{registerItem.nameCn}}
                </div>
                <!-- 退费申请按钮 -->
                <div class="mobile-refund-btn" v-if="refundItem" @click="handleMobileMenuClick(refundItem)">
                    {{refundItem.nameCn}}
                </div>
                <!-- 年会报名按钮 -->
                <div class="mobile-register-btn" v-if="annualItem" @click="handleMobileMenuClick(annualItem)">
                    {{annualItem.nameCn}}
                </div>
            </div>
        </div>
        
        <!-- 遮罩层 -->
        <div class="mobile-menu-overlay" :class="{ 'show': showMobileMenu }" @click="closeMobileMenu"></div>
    </div>
</template>

<script>
export default {
    name: 'top',
    data() {
        return {
            menuList: [],
            currentActiveId: null, // 当前选中的菜单项ID
            showMobileMenu: false, // 控制移动端菜单显示
            // 控制是否跳转外部链接
            isJumpExternalLink: false,
            logoURL:'',
            LogoStatus: 0
        }
    },

    computed: {
        // 过滤后的菜单列表，只显示 display 为 1 或 '1' 的菜单项
        filteredMenuList() {
            return this.menuList.filter(item => {
                const display = item?.jsonExt?.cn?.display;
                return display === 1 || display === '1';
            });
        },
        
        // 查找"登录/注册"菜单项的索引
        registerIndex() {
            return this.filteredMenuList.findIndex(item => item?.nameCn === '登录/注册');
        },
        
        // 登录/注册之前的菜单项（普通导航菜单）
        beforeRegisterItems() {
            if (this.registerIndex === -1) {
                return this.filteredMenuList;
            }
            return this.filteredMenuList.slice(0, this.registerIndex);
        },
        
        // 登录/注册菜单项
        registerItem() {
            if (this.registerIndex === -1) {
                return null;
            }
            return this.filteredMenuList[this.registerIndex];
        },
        
        // 退费申请菜单项
        refundItem() {
            return this.filteredMenuList.find(item => item?.nameCn === '退费申请');
        },

        // 年会报名菜单项不依赖接口中的相邻顺序
        annualItem() {
            return this.filteredMenuList.find(item => item?.nameCn === '年会报名');
        }
    },

     mounted() {
        console.log('顶部导航栏组件已挂载');
        this.getMenu();
        this.getlogoURL();
        // 处理 BFCache 恢复的场景（浏览器后退返回首页时）
        this._onPageShow = () => {
            this.syncActiveByRoute();
        };
        window.addEventListener('pageshow', this._onPageShow);
    },
    // 清理事件监听
    beforeUnmount() {
        if (this._onPageShow) {
            window.removeEventListener('pageshow', this._onPageShow);
        }
    },
    watch: {
        // 路由变化时，同步选中态
        $route: {
            immediate: true,
            handler() {
                this.syncActiveByRoute();
            }
        }
    },
    methods: {
        // 获取菜单
        getMenu() {
            // console.log('获取菜单');
            this.$httpOw('get', `/x/${this.$store.state.showID}/static/cms_menu/default.json`, {}, (res) => { 
                console.log('菜单res ==>', res);  
                if (res.status == 200) { 
                    const menuLists = res.data.treeData;
                    // console.log('menuLists ==>', menuLists.slice(0, 10));
                    
                    this.menuList = menuLists;
                    

                    // console.log('this.menuList ==>', this.menuList);
                // 默认选中第一项（首页）- 使用登录/注册之前的菜单列表
                if (this.beforeRegisterItems.length > 0) {
                    this.currentActiveId = this.beforeRegisterItems[0].id;
                }
                // 加载完菜单后，根据当前路由再次同步一次选中态
                this.syncActiveByRoute();
              }
            })
        },
        
        // 根据当前端类型获取菜单跳转链接：移动端使用 href.url，PC端优先使用 params 中的 PC 链接
        getMenuTargetUrl(href) {
            if (this.isMobileViewport()) {
                return href?.url || '';
            }

            const params = href?.params;
            const pcParam = Array.isArray(params)
                ? params.find(param => String(param?.key).toUpperCase() === 'PC')
                : params?.PC;
            const pcUrl = typeof pcParam === 'object' ? pcParam?.value : pcParam;

            // 其他没有 PC 参数的菜单继续使用原来的 url 字段
            return pcUrl || href?.url || '';
        },

        // 使用视口宽度判断端类型，与当前响应式布局保持一致
        isMobileViewport() {
            if (typeof window === 'undefined') {
                return false;
            }

            return window.matchMedia
                ? window.matchMedia('(max-width: 768px)').matches
                : window.innerWidth <= 768;
        },

        // 菜单点击处理
        handleMenuClick(item) {
            // console.log('handleMenuClick', item);
            const href = item?.jsonExt?.href;
            const Type = href?.type;
            const targetUrl = this.getMenuTargetUrl(href);
            const pageId = href?.page;
            
            // 添加详细的调试信息
            // console.log('菜单项详细信息:', {
            //     id: item?.id,
            //     nameCn: item?.nameCn,
            //     href: href,
            //     type: Type,
            //     targetUrl: targetUrl,
            //     pageId: pageId
            // });

           

            // 检查URL是否为空，如果为空则显示敬请期待提示
            if (Type === 'url' && !this.isValidExternalUrl(targetUrl)) {
                this.showComingSoonMessage();
                return;
            }
             // 特殊处理：大会直播 (id=5217) 显示敬请期待提示
             if (item?.id === 5217) {
                if (item?.id) this.setActiveItem(item.id);
                // this.showComingSoonMessage();
                this.$navigate.navigateWithP('conference');
                return;
            }

            if (Type === 'url' && targetUrl) {
                // 外链不设置选中态，避免返回时仍保留之前高亮
                window.location.href = targetUrl;
                return;
            } else if (Type === 'page' && pageId) { 
                // 特殊：当 pageId 为 1443 时跳转 About 页面
                if (String(pageId) === '1443') {
                    if (item?.id) this.setActiveItem(item.id);
                    this.$navigate.navigateWithP('person', { id: pageId });
                    return;
                }
                if (String(pageId) === '1444') {
                    if (item?.id) this.setActiveItem(item.id);
                    this.$navigate.navigateWithP('contact', { pageId });
                    return;
                }
                // 移除 3512 的特殊处理，让它和其他 pageId 一样跳转到 page 页面
                if (String(pageId) === '3512') {
                    if (item?.id) this.setActiveItem(item.id);
                    this.$navigate.navigateWithP('detail', { pageId });
                    return;
                }
                if (item?.id) this.setActiveItem(item.id);
                this.$navigate.navigateWithP('page', { pageId });
                return;
            } else if (item?.id && item.id === this.menuList?.[0]?.id) {
                // 首页：点击应回到根路由
                this.setActiveItem(item.id);
                this.$navigate.toIndexPage();
                return;
            }
            
            // 兜底处理：如果没有任何匹配的条件，至少设置选中状态
            // console.log('没有匹配到任何跳转条件，仅设置选中状态');
            if (item?.id) this.setActiveItem(item.id);
        },
        
        // 移动端菜单点击处理
        handleMobileMenuClick(item) {
            // 先关闭移动端菜单
            this.closeMobileMenu();
            // 然后执行正常的菜单点击逻辑
            this.handleMenuClick(item);
        },
        
        // 切换移动端菜单显示状态
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
            // 防止背景滚动
            if (this.showMobileMenu) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },
        
        // 关闭移动端菜单
        closeMobileMenu() {
            this.showMobileMenu = false;
            document.body.style.overflow = '';
        },
        
        // 设置当前选中的菜单项
        setActiveItem(itemId) {
            console.log('设置当前选中的菜单项', itemId);
            this.currentActiveId = itemId;
            console.log(this.currentActiveId);
            
            // 这里可以添加路由跳转逻辑
            // this.$router.push('/some-path');
        },

        // 显示敬请期待提示
        showComingSoonMessage() {
            // 使用浏览器原生提示框
            // alert('敬请期待！');
            
            // 或者使用更美观的提示方式（可选）
            this.$message({
                message: '敬请期待！',
                type: 'info',
                duration: 2000
            });
        },

        // 检查外部链接是否有效
        isValidExternalUrl(url) {
            if (!url || typeof url !== 'string') {
                return false;
            }
            
            const trimmedUrl = url.trim();
            if (trimmedUrl === '' || trimmedUrl === '#' || trimmedUrl === 'javascript:void(0)') {
                return false;
            }
            
            // 检查是否是有效的URL格式
            try {
                new URL(trimmedUrl);
                return true;
            } catch {
                // 如果不是完整URL，检查是否是相对路径
                return trimmedUrl.startsWith('/') || trimmedUrl.startsWith('./') || trimmedUrl.startsWith('../');
            }
        },

        // 根据当前路由同步选中态
        syncActiveByRoute() {
            if (!Array.isArray(this.filteredMenuList) || this.filteredMenuList.length === 0) return;
            const route = this.$route || {};
            const pageParam = route.query?.p;
            
            // 根据 p 参数确定当前页面类型
            if (!pageParam || pageParam === 'index') {
                this.currentActiveId = this.beforeRegisterItems[0]?.id ?? null;
                return;
            }
            
            // person 页面：根据路由参数 id 匹配菜单中的 page 字段
            if (pageParam === 'person') {
                const aboutId = route.query?.id;
                const foundAbout = this.filteredMenuList.find(m => String(m?.jsonExt?.href?.page) === String(aboutId));
                if (foundAbout) {
                    this.currentActiveId = foundAbout.id;
                }
                return;
            }
            
            // contact 页面
            if (pageParam === 'contact') {
                const pageId = route.query?.pageId;
                const found = this.filteredMenuList.find(m => String(m?.jsonExt?.href?.page) === String(pageId));
                if (found) {
                    this.currentActiveId = found.id;
                }
                return;
            }
            
            // page 页面
            if (pageParam === 'page') {
                const pageId = route.query?.pageId;
                const found = this.filteredMenuList.find(m => m?.jsonExt?.href?.type === 'page' && String(m?.jsonExt?.href?.page) === String(pageId));
                if (found) {
                    this.currentActiveId = found.id;
                }
                return;
            }
            
            // conference 页面 - 如果还有其他conference相关页面需要处理
            if (pageParam === 'conference') {
                // 查找id为5217的菜单项（大会直播）
                const conferenceItem = this.filteredMenuList.find(m => m?.id === 5217);
                if (conferenceItem) {
                    this.currentActiveId = conferenceItem.id;
                }
                return;
            }
            
            // detail 页面 - 保持当前选中状态不变
            if (pageParam === 'detail') {
                // 详情页通常从其他页面跳转而来，保持当前的菜单选中状态
                return;
            }
        },

        getlogoURL() {
            this.$httpOw('get', `/x/${this.$store.state.showID}/static/site/default.json`, {}, res => {
                console.log('logoURL', res);
                if(res.status == 200) {
                    // this.logoURL = res.data.json?.banner?.index?.items[1]?.cn?.url;
                    const item =res?.data?.json?.banner?.index?.items[1]

                        // 兼容接口返回数字 1 或字符串 "1"
                        this.LogoStatus = Number(item?.status || 0)

                        // this.logoURL = item?.cn?.url || ''
                        this.logoURL = 'https://portal.csee.org.cn/js/userfiles/logo/logo1.png'+'?t='+Date.now();
                }
            })
        }
    }
}
</script>

<style scoped>
.top-nav {
    background-color: #fff;
    /* border-bottom: 1px solid #e5e5e5; */
    padding: 10px 0;
    position: sticky;
    top: 0;
    z-index: 1000;
    /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
}

.nav-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* padding: 0 20px; */
    height: 70px;
}

/* Logo部分样式 */
.logo-section {
    display: flex;
    align-items: center;
    gap: 15px;
}

.logo {
    display: flex;
    align-items: center;
    width: 180px;
}

.logo img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}

.logo-text {
    display: flex;
    flex-direction: column;
}

.org-name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 1.2;
}

/* PC端导航菜单样式 */
.desktop-menu {
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
    justify-content: flex-end;
}

.nav-item {
    font-size: 20px;
    color: #333;
    cursor: pointer;
    padding: 10px 12px;
    border-radius: 4px;
    transition: all 0.3s ease;
    white-space: nowrap;
    position: relative;
    /* 移除原来的 border-bottom */
}

.nav-item:hover {
    /* background-color: #f5f5f5; */
    color:#156eeb;
}

/* 选中状态的样式 */
.nav-item.active {
    color:#156eeb; /* 橙色文字 */
    background-color: transparent;
}

.nav-item.active:hover {
    color:#156eeb; /* 保持橙色 */
    background-color: #fff5f0; /* 浅橙色背景 */
}

/* 使用伪元素创建完整下划线 */
.nav-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(135deg,#156eeb 0%, #3cc3a1 100%);
    border-radius: 1px;
}

/* 注册按钮样式 */
.register-btn {
    /* background: #ff6a00; */
    background: linear-gradient(135deg,#156eeb 0%, #3cc3a1 100%);
    color: white;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 16px;
    /* font-weight: 600; */
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    /* box-shadow: 0 2px 8px #156eeb; */
}

/* 仅移动端显示的年会报名按钮 */
.register-btn.mobile-only {
    display: none;
    /* 稍微小一点 */
    padding: 8px 16px;
    font-size: 14px;
    /* 去掉阴影 */
    box-shadow: none;
    /* 靠近右侧按钮 */
    margin-left: 8px;
}

.register-btn:hover {
    background: linear-gradient(135deg,#156eeb 0%, #3cc3a1 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px #156eeb;
}

/* 移动端年会报名按钮的hover状态 - 去掉阴影 */
.register-btn.mobile-only:hover {
    box-shadow: none;
    transform: none;
}

/* 退费申请按钮样式 - PC端 */
.refund-btn {
    background: #fff;
    color: #333;
    border: 1px solid #156eeb;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
}

.refund-btn:hover {
    background: #f0f7ff;
    border-color: #156eeb;
    color: #156eeb;
}

/* 退费申请按钮样式 - 移动端 */
.mobile-refund-btn {
    background: #fff;
    color: #333;
    border: 1px solid #156eeb;
    padding: 12px 20px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
    margin-top: 20px;
}

.mobile-refund-btn:hover {
    background: #f0f7ff;
    border-color: #156eeb;
    color: #156eeb;
}

/* 移动端汉堡菜单按钮 */
.mobile-menu-btn {
    display: none;
    cursor: pointer;
    padding: 8px;
    z-index: 1001;
}

/* 汉堡菜单图标 */
.hamburger {
    width: 24px;
    height: 18px;
    position: relative;
    transform: rotate(0deg);
    transition: 0.3s ease-in-out;
}

.hamburger span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background:#00a79f;
    border-radius: 1px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
}

.hamburger span:nth-child(1) {
    top: 0px;
}

.hamburger span:nth-child(2) {
    top: 8px;
}

.hamburger span:nth-child(3) {
    top: 16px;
}

/* 汉堡菜单激活状态 */
.hamburger.active span:nth-child(1) {
    top: 8px;
    transform: rotate(135deg);
}

.hamburger.active span:nth-child(2) {
    opacity: 0;
    left: -60px;
}

.hamburger.active span:nth-child(3) {
    top: 8px;
    transform: rotate(-135deg);
}

/* 移动端菜单面板 */
.mobile-menu-panel {
    position: fixed;
    top: 0;
    right: -100%;
    width: 80%;
    max-width: 300px;
    height: 100vh;
    background: #fff;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    transition: right 0.3s ease-in-out;
    z-index: 999;
    padding-top: 80px;
}

.mobile-menu-panel.show {
    right: 0;
}

.mobile-menu-content {
    padding: 20px;
}

/* 移动端菜单项 */
.mobile-nav-item {
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    color: #333;
    font-size: 16px;
    cursor: pointer;
    transition: color 0.3s ease;
}

.mobile-nav-item:hover,
.mobile-nav-item.active {
    color: #156eeb;
}

.mobile-nav-item:last-of-type {
    border-bottom: none;
}

/* 移动端注册按钮 */
.mobile-register-btn {
    background: linear-gradient(135deg,#156eeb 0%, #3cc3a1 100%);
    color: white;
    padding: 12px 20px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
    margin-top: 20px;
}

.mobile-register-btn:hover {
    background: linear-gradient(135deg,#156eeb 0%, #3cc3a1 100%);
    transform: translateY(-1px);
}

/* 遮罩层 */
.mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    z-index: 998;
}

.mobile-menu-overlay.show {
    opacity: 1;
    visibility: visible;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .top-nav {
        padding: 5px 0;
    }
    
    .nav-container {
        padding: 0 15px;
        height: 50px;
    }
    
    .logo-section {
        flex: 0 0 auto;
    }
    
    .logo {
        width: 90px;
    }
    
    .logo img {
        height: 40px;
    }
    
    /* 隐藏PC端菜单，显示移动端按钮 */
    .desktop-menu {
        display: none;
    }
    
    .mobile-menu-btn {
        display: block;
    }
    
    /* 在移动端显示年会报名按钮 */
    .register-btn.mobile-only {
        display: block;
        margin-left: 30%;
        padding: 6px 12px;
        font-size: 13px;
    }
}

@media (max-width: 480px) {
    .nav-container {
        height: 48px;
        padding: 0 10px;
    }
    
    .logo {
        width: 80px;
    }
    
    .logo img {
        height: 36px;
    }
    
    .mobile-menu-panel {
        width: 85%;
        padding-top: 60px;
    }
    
    .register-btn.mobile-only {
        padding: 5px 10px;
        font-size: 12px;
    }
}
</style>
